'use client';

import type { PropsWithChildren } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { usePaginationState } from '@/components/Pagination/PaginationContext';
import { cn } from '@/lib/cn';
import { useFilteredBlogPostState } from './FilteredBlogPostProvider';

export function FilteredBlogPostListPage({ children }: PropsWithChildren) {
    const { isOnSamePage, visiblePostIds } = useFilteredBlogPostState();
    const { page, prevPage } = usePaginationState();

    return visiblePostIds.length > 0 ? (
        <div
            className={cn('mb-6', {
                'overflow-hidden': !isOnSamePage,
            })}
        >
            <AnimatePresence mode="wait">
                <motion.div
                    className="flex flex-wrap gap-6 flex-col sm:flex-row pt-4 md:pt-6"
                    key={page}
                    initial={{ x: `${prevPage.current < page ? '' : '-'}100%`, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: `${prevPage.current < page ? '' : '-'}100%`, opacity: 0 }}
                >
                    <AnimatePresence presenceAffectsLayout={isOnSamePage}>{children}</AnimatePresence>
                </motion.div>
            </AnimatePresence>
        </div>
    ) : (
        <div className="flex items-center justify-center pt-4 md:pt-6">Looks like your road to inspiration hit a dead end. Try tweaking those filters and get rolling again!</div>
    );
}
